import React from 'react';
import {useIsFetching, useQueryClient} from "react-query";
import {Stack} from "../ui";

import './Loader.css';

function Loader() {
	const isFetching = useIsFetching();
	const queryClient = useQueryClient();

	const queryKeys = queryClient.getQueryCache().getAll().map(query => query.queryKey);

	const fetchingQueries = queryKeys.filter(key => {
		const state = queryClient.getQueryState(key);
		return state?.isFetching;
	});

	if(!isFetching || !fetchingQueries.length) return <></>;

	return (
		<Stack className="loader items-center justify-center">
			<span className="loading loading-ring loading-lg" aria-label="Loader"></span>
		</Stack>
	);
}

export default Loader;